module.exports = function(h, row) {
    let url = 'https://www.billplz.com/bills/' + row.bill_id;
    // let url = 'https://billplz-staging.herokuapp.com/bills/' + row.bill_id;

    if (row.bill_id) {
        return (
            <a class="btn btn-xs btn-info" target="_blank" href={url}>
                {row.bill_id}
            </a>
        );
    } else {
        return '';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/coupon/bill_id.jsx